<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
  <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
  <el-breadcrumb-item>学习汇报</el-breadcrumb-item>
  <el-breadcrumb-item>雅思申报列表</el-breadcrumb-item>
</el-breadcrumb>
<el-card>
 <el-table
    ref="ieltsList"
    :data="ieltsList"
    border
    show-overflow-tooltip="true"
    tooltip-effect="dark"
    style="width: 100%">
    <el-table-column
      prop="studentID"
      :show-overflow-tooltip="true"
      label="学号"
      width="110">
    </el-table-column>
     <el-table-column
      prop="listening"
      :show-overflow-tooltip="true"
      label="listening"
      width="100">
    </el-table-column>

     <el-table-column
      prop="reading"
      label="reading"
      width="100">
    </el-table-column>
     <el-table-column
      prop="writing"
      label="writing"
      width="100">
    </el-table-column>
     <el-table-column
      prop="speaking"
      label="speaking"
      :show-overflow-tooltip="true"
      width="100">
    </el-table-column>
     <el-table-column
      prop="overBandScore"
      label="overBandScore"
      :show-overflow-tooltip="true"
      width="150">
    </el-table-column>
     <el-table-column
      prop="cefrlevel"
      label="CEFRlevel"
      width="100">
    </el-table-column>
     <el-table-column
      prop="ukvinumber"
      label="UKVINumber"
      width="120">
    </el-table-column>
    <el-table-column
      prop="examTime"
      label="考试时间"
      width="120">
    </el-table-column>
         <el-table-column
      prop="examAddress"
      label="考试地点"
      :show-overflow-tooltip="true"
      width="180">
    </el-table-column>
     <el-table-column
      prop="examType"
      label="考试形式"
      width="100">
    </el-table-column>
  </el-table>

</el-card>
  </div>
</template>

<script>
export default {
created(){
  this.getIelts()
},
data(){
  return{
  ieltsList:[],
  }
},
methods:{
  getIelts(){
         this.axios.post("/user/getUserByID","userid="+JSON.parse(localStorage.getItem('user')).userid)
 .then(resp=>{
              if(resp.data.status==1){
               console.log(resp.data.result)
               
                if(resp.data.result.studentID==null||resp.data.result.studentID==''){
                 alert("请先完善个人信息")
                return
               }
               
        this.axios.post("/ielts/getIeltsById?studentId="+resp.data.result.studentID)
        .then((resp) => {
          if (resp.data.status == 1) {
            console.log(resp.data.result)
            this.ieltsList=resp.data.result
          } else {
            alert("拿取数据失败");
          }
        })
        .catch((err) => {
          this.$message.error("出错");
        });
              }
             })

  }
}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/work/student/ViewIelts.vue